import React, { useState, useEffect } from "react";
import { apiFetch } from "../../services/apiFetch";

export default function FollowersPage() {
  const [followers, setFollowers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [totalFollowers, setTotalFollowers] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;

  useEffect(() => {
    fetchFollowers();
  }, []);

  const fetchFollowers = async () => {
    try {
      setLoading(true);
      setError("");
      const vendorId = localStorage.getItem("vendor_id") 
  || localStorage.getItem("vendorId")
  || (() => {
      try {
        const vm = JSON.parse(localStorage.getItem("vendor_me") || "{}");
        return vm.id || null;
      } catch { return null; }
    })();

      if (!vendorId) {
        setError("Vendor ID not found");
        return;
      }

      const response = await apiFetch(
        `/vendor/get_followers.php?vendor_id=${vendorId}`,
        { method: "GET", token: localStorage.getItem("vendor_token") }
      );

      if (response.success) {
        setFollowers(response.followers || []);
        setTotalFollowers(response.total_followers || 0);
        setCurrentPage(1);
      } else {
        setError(response.message || "Failed to fetch followers");
      }
    } catch (err) {
      setError(err.message || "Failed to fetch followers");
    } finally {
      setLoading(false);
    }
  };

  const paginatedFollowers = followers.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  if (loading) {
    return (
      <div style={{ padding: "32px", textAlign: "center", color: "#888" }}>
        Loading followers...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: "32px", textAlign: "center" }}>
        <div style={{ color: "#dc3545", marginBottom: "16px" }}>{error}</div>
        <button onClick={fetchFollowers} style={retryBtnStyle}>Retry</button>
      </div>
    );
  }

  return (
    <div style={{ padding: "32px", maxWidth: "900px", margin: "0 auto" }}>

      {/* ── Header (matches Inventory style) ── */}
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "28px"
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <div style={{
            width: "52px", height: "52px", borderRadius: "14px",
            backgroundColor: "#1a1a1a",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: "24px"
          }}>
            👥
          </div>
          <div>
            <h1 style={{ margin: 0, fontSize: "26px", fontWeight: "700", color: "#111", letterSpacing: "-0.5px" }}>
              Followers
            </h1>
            <p style={{ margin: "2px 0 0 0", fontSize: "13px", color: "#888" }}>
              {totalFollowers} follower{totalFollowers !== 1 ? "s" : ""} · vendor #{localStorage.getItem("vendor_id")}
            </p>
          </div>
        </div>
        <button onClick={fetchFollowers} style={refreshBtnStyle}>
          Refresh
        </button>
      </div>

      {/* ── Stat Card (matches Inventory stat cards) ── */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
        gap: "16px",
        marginBottom: "28px"
      }}>
        <div style={statCardStyle}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
            <span style={{ fontSize: "20px" }}>🧑‍🤝‍🧑</span>
            <span style={{ fontSize: "13px", color: "#666", fontWeight: "500" }}>Total Followers</span>
          </div>
          <div style={{ fontSize: "36px", fontWeight: "800", color: "#111", lineHeight: 1 }}>
            {totalFollowers}
          </div>
        </div>
      </div>

      {/* ── Followers List ── */}
      {followers.length === 0 ? (
        <div style={{
          textAlign: "center", padding: "56px 24px",
          backgroundColor: "#f8f9fa", borderRadius: "12px",
          border: "1px solid #e9ecef"
        }}>
          <div style={{ fontSize: "52px", marginBottom: "12px", opacity: 0.25 }}>👥</div>
          <h3 style={{ margin: "0 0 6px 0", color: "#555", fontWeight: "600" }}>No followers yet</h3>
          <p style={{ margin: 0, color: "#999", fontSize: "14px" }}>
            When users follow your store, they will appear here
          </p>
        </div>
      ) : (
        <div style={{
          backgroundColor: "white", borderRadius: "12px",
          border: "1px solid #e9ecef", overflow: "hidden",
          boxShadow: "0 1px 4px rgba(0,0,0,0.06)"
        }}>
          {/* Table header */}
          <div style={{
            display: "grid", gridTemplateColumns: "60px 1fr",
            padding: "12px 20px",
            backgroundColor: "#f8f9fa", borderBottom: "1px solid #e9ecef",
            fontWeight: "700", fontSize: "12px", color: "#6c757d",
            textTransform: "uppercase", letterSpacing: "0.6px"
          }}>
            <div>S.NO</div>
            <div>USER NAME</div>
          </div>

          {/* Rows */}
          {paginatedFollowers.map((follower, index) => (
            <div
              key={follower.user_id}
              style={{
                display: "grid", gridTemplateColumns: "60px 1fr",
                padding: "14px 20px",
                borderBottom: index < paginatedFollowers.length - 1 ? "1px solid #f1f3f4" : "none",
                alignItems: "center",
                transition: "background-color 0.15s"
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f8f9fa"}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "white"}
            >
              {/* S.NO */}
              <div style={{ fontSize: "13px", color: "#aaa", fontWeight: "600" }}>
                {(currentPage - 1) * itemsPerPage + index + 1}
              </div>

              {/* Name with avatar */}
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <div style={{
                  width: "38px", height: "38px", borderRadius: "50%",
                  backgroundColor: avatarColor(follower.name),
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: "15px", fontWeight: "700", color: "white",
                  flexShrink: 0
                }}>
                  {follower.name ? follower.name.charAt(0).toUpperCase() : "U"}
                </div>
                <span style={{ fontWeight: "600", fontSize: "15px", color: "#111" }}>
                  {follower.name || "Unknown User"}
                </span>
              </div>
            </div>
          ))}
          {/* Pagination Controls */}
          {followers.length > itemsPerPage && (
            <div style={{
              display: "flex", justifyContent: "space-between", alignItems: "center",
              padding: "16px 20px", borderTop: "1px solid #e9ecef", backgroundColor: "#f8f9fa"
            }}>
              <div style={{ fontSize: "13px", color: "#6c757d" }}>
                Showing {(currentPage - 1) * itemsPerPage + 1} to {Math.min(currentPage * itemsPerPage, followers.length)} of {followers.length}
              </div>
              <div style={{ display: "flex", gap: "8px" }}>
                <button
                  onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                  style={{
                    padding: "6px 12px", borderRadius: "6px", border: "1px solid #dee2e6",
                    backgroundColor: currentPage === 1 ? "#e9ecef" : "white",
                    color: currentPage === 1 ? "#adb5bd" : "#333",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    fontSize: "13px", fontWeight: "600"
                  }}
                >
                  Previous
                </button>
                <button
                  onClick={() => setCurrentPage(p => Math.min(Math.ceil(followers.length / itemsPerPage), p + 1))}
                  disabled={currentPage === Math.ceil(followers.length / itemsPerPage)}
                  style={{
                    padding: "6px 12px", borderRadius: "6px", border: "1px solid #dee2e6",
                    backgroundColor: currentPage === Math.ceil(followers.length / itemsPerPage) ? "#e9ecef" : "white",
                    color: currentPage === Math.ceil(followers.length / itemsPerPage) ? "#adb5bd" : "#333",
                    cursor: currentPage === Math.ceil(followers.length / itemsPerPage) ? "not-allowed" : "pointer",
                    fontSize: "13px", fontWeight: "600"
                  }}
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

/* ── Helpers ── */
function avatarColor(name) {
  const colors = ["#4f46e5","#0891b2","#059669","#d97706","#dc2626","#7c3aed","#db2777"];
  if (!name) return "#9ca3af";
  const i = name.charCodeAt(0) % colors.length;
  return colors[i];
}

const refreshBtnStyle = {
  padding: "9px 20px",
  backgroundColor: "white",
  border: "1.5px solid #dee2e6",
  borderRadius: "8px",
  cursor: "pointer",
  fontSize: "14px",
  fontWeight: "600",
  color: "#333",
  transition: "border-color 0.15s"
};

const retryBtnStyle = {
  padding: "9px 20px",
  backgroundColor: "#007bff",
  color: "white",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontSize: "14px",
  fontWeight: "600"
};

const statCardStyle = {
  backgroundColor: "white",
  border: "1.5px solid #e9ecef",
  borderRadius: "12px",
  padding: "20px",
  boxShadow: "0 1px 4px rgba(0,0,0,0.05)"
};